module.exports = __webpack_public_path__ + "img/img_throw_5@2x_v2.b9145e08.png";